module.exports = __webpack_public_path__ + "static/img/31.23b9a4ae.png";